import React, { useEffect, useRef, useState } from "react";

export default function AppCheckbox({
  label,
  description,
  error,
  className = "",
  alignment = "auto",
  labelVariant = "label-1",
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  invalid = false,
  indeterminate = false,
  ...props
}) {
  const inputRef = useRef(null);
  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  const currentChecked = isControlled ? checked : internalChecked;
  const hasSupportingText = Boolean(description || error);
  const resolvedAlignment = alignment === "auto" ? (hasSupportingText ? "start" : "center") : alignment;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.indeterminate = Boolean(indeterminate);
    }
  }, [indeterminate]);

  function handleChange(event) {
    if (!isControlled) {
      setInternalChecked(event.target.checked);
    }
    if (onChange) {
      onChange(event);
    }
  }

  const classes = [
    "ds-checkbox-field",
    currentChecked ? "ds-checkbox-field--checked" : "",
    indeterminate ? "ds-checkbox-field--indeterminate" : "",
    disabled ? "ds-checkbox-field--disabled" : "",
    invalid || error ? "ds-checkbox-field--invalid" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const checkboxClasses = [
    "ds-checkbox",
    resolvedAlignment === "center" ? "ds-checkbox--align-center" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const labelClasses = [
    "ds-checkbox__label",
    labelVariant === "body-1" ? "ds-checkbox__label--body-1" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <label className={checkboxClasses}>
        <input
          ref={inputRef}
          className="ds-checkbox__input"
          type="checkbox"
          checked={Boolean(currentChecked)}
          disabled={disabled}
          aria-invalid={invalid || error ? "true" : undefined}
          onChange={handleChange}
          {...props}
        />
        <span className="ds-checkbox__control" aria-hidden="true">
          <span className="ds-checkbox__box">
            <span className="ds-checkbox__mark">
              {indeterminate ? (
                <svg viewBox="0 0 12 12" className="ds-checkbox__mark-icon ds-checkbox__mark-icon--indeterminate">
                  <path d="M2.5 6H9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              ) : (
                <svg viewBox="0 0 12 12" className="ds-checkbox__mark-icon ds-checkbox__mark-icon--check">
                  <path
                    d="M2.5 6.2L4.9 8.6L9.5 3.7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </span>
        </span>
        {label || description || error ? (
          <span className="ds-checkbox__content">
            {label ? <span className={labelClasses}>{label}</span> : null}
            {description && !error ? <span className="ds-checkbox__description">{description}</span> : null}
            {error ? <span className="ds-checkbox__error">{error}</span> : null}
          </span>
        ) : null}
      </label>
    </div>
  );
}
